import { RemoveUserRoleType } from "../../types/Role";
import { del, post } from "../../utils/axios-config";
import { REMOVE_USER_ROLE } from "../../utils/constants";

export const addUserRole = async (data:RemoveUserRoleType) => await post<RemoveUserRoleType,boolean>(REMOVE_USER_ROLE, data);